import React, { useEffect, useState } from "react";
import { InputAdornment, Box, Badge } from "@mui/material";

interface PriceInputRowProps {
  icon: React.ReactNode;
  fobValue: string;
  altValue: string;
  onFobChange: (value: string) => void;
  onAltChange: (value: string) => void;
  hasUpdate: boolean;
}

const PriceInputRow: React.FC<PriceInputRowProps> = ({
  icon,
  fobValue,
  altValue,
  onFobChange,
  onAltChange,
  hasUpdate,
}) => {
  const [isFobFocused, setIsFobFocused] = useState(false);
  const [isAltFocused, setIsAltFocused] = useState(false);
  const [position, setPosition] = useState<number>(62);
  const [fobPrice, setFobPrice] = useState<string>(fobValue);
  const [altPrice, setAltPrice] = useState<string>(altValue);

  const handleBlur = (e: React.FocusEvent<HTMLDivElement>) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsFobFocused(false);
      setIsAltFocused(false);
    }
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Tab") {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  useEffect(() => {
    if (fobPrice.length === 1) {
      setPosition(52);
    } else if (fobPrice.length === 2) {
      setPosition(56);
    } else if (fobPrice.length === 3) {
      setPosition(59);
    } else {
      setPosition(62);
    }
  }, [fobPrice]);

  return (
    <Box className="price-input-container">
      <Badge
        color="primary"
        variant="dot"
        invisible={!hasUpdate}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        className="price-input-badge"
      >
        <InputAdornment position="start" style={{ paddingTop: 11 }}>
          {icon}
        </InputAdornment>
        <div className={`price-input-items ${isFobFocused ? "focused" : ""}`}>
          <input
            id="fob-price"
            className="price-input-fob-desktop"
            type="text"
            onFocus={() => setIsFobFocused(true)}
            onBlur={handleBlur}
            onKeyDown={handleInputKeyDown}
            placeholder="FOB"
            value={`${fobPrice}`}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
              setFobPrice(value);
              onFobChange(value);
            }}
          />
          <span
            style={{
              color: "#DC2626",
              fontSize: "13px",
              position: "absolute",
              top: 3,
              left: position,
            }}
          >
            *
          </span>
        </div>
        <div
          className={`price-input-items ${isAltFocused ? "focused" : ""}`}
          style={{ marginLeft: 10 }}
        >
          <input
            className="price-input-alt-desktop"
            type="number"
            onFocus={() => setIsAltFocused(true)}
            onBlur={handleBlur}
            onKeyDown={handleInputKeyDown}
            placeholder="ALT"
            value={altPrice}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 4);
              setAltPrice(value);
              onAltChange(value);
            }}
          />
        </div>
      </Badge>
    </Box>
  );
};

export default PriceInputRow;
